import React, { useRef, useEffect } from 'react';

import { useLocation, Switch } from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';

import ReactGA from 'react-ga';

import { I18nextProvider } from "react-i18next";
import i18n from "./translation";

import LayoutDefault from './layouts/LayoutDefault';

// Views
import Home from './views/Home';
import SignUp from './views/SignUp';

// Initialize Google Analytics
ReactGA.initialize(process.env.REACT_APP_GA_CODE);

const trackPage = page => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

const App = () => {

  const childRef = useRef();
  let location = useLocation();

  useEffect(() => {
    const page = location.pathname;
    document.body.classList.add('is-loaded')
    childRef.current.init();
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <ScrollReveal
      ref={childRef}
      children={() => (
        <I18nextProvider i18n={i18n}>
          <Switch>
            <AppRoute path="/signup" component={SignUp} layout={LayoutDefault} />
            <AppRoute exact path="/" component={Home} layout={LayoutDefault} />
          </Switch>
        </I18nextProvider>
      )} />
  );
}

export default App;
